import { RadioButton } from "components/common/RadioButton";
import { VisibleSection } from "components/common/VisibleSection";
import { ONE, THREE, TWO, ZERO } from "domain/aboutYourLoan";
import { Nullable } from "util/extendedTypes";
import {
  NO_OF_CRH_TAKEN,
  NO_OF_CRH_TAKEN_ONE,
  NO_OF_CRH_TAKEN_THREE,
  NO_OF_CRH_TAKEN_TWO,
  ONE_CRH_QUESTION,
  ONE_CRH_QUESTION_ANSWER_1,
  ONE_CRH_QUESTION_ANSWER_2,
  OTHER_CRH_QUESTION,
  OTHER_CRH_QUESTION_ANSWER_1,
  OTHER_CRH_QUESTION_ANSWER_2,
  THREE_CRH_QUESTION_ANSWER_3,
  THREE_CRH_QUESTION_ANSWER_4,
  TWO_CRH_QUESTION_ANSWER_3,
} from "./YourLoan.const";

type CRHQuestionsProps = {
  CRHTakenvalue: Nullable<number>;
  onCRHTakenCountChange: (v: number) => void;
  onCRHWithExtensionCountChange: (v: number) => void;
  CRHWithTermExtensionTakenValue: Nullable<number>;
};
export const CRHQuestions = ({
  CRHTakenvalue,
  onCRHTakenCountChange,
  onCRHWithExtensionCountChange,
  CRHWithTermExtensionTakenValue,
}: CRHQuestionsProps) => {
  return (
    <>
      <fieldset>
        <label id="CRHOptions" className="title">
          {NO_OF_CRH_TAKEN}
        </label>
        <div className="customLabelRawRadios">
          <RadioButton
            name="CRHOptions"
            label={NO_OF_CRH_TAKEN_ONE}
            isSelected={CRHTakenvalue === ONE}
            onChange={() => onCRHTakenCountChange(ONE)}
            disabled={false}
          />
          <RadioButton
            name="CRHOptions"
            label={NO_OF_CRH_TAKEN_TWO}
            isSelected={CRHTakenvalue === TWO}
            onChange={() => onCRHTakenCountChange(TWO)}
            disabled={false}
          />
          <RadioButton
            name="CRHOptions"
            label={NO_OF_CRH_TAKEN_THREE}
            isSelected={CRHTakenvalue === THREE}
            onChange={() => onCRHTakenCountChange(THREE)}
            disabled={false}
          />
        </div>
      </fieldset>
      <VisibleSection visible={!!CRHTakenvalue}>
        <fieldset>
          <label id="CRHWithExtensionCount" className="title">
            {CRHTakenvalue === ONE ? ONE_CRH_QUESTION : OTHER_CRH_QUESTION}
          </label>
          <div className="customLabelRawRadios">
            <RadioButton
              name="CRHWithExtensionCount"
              label={
                CRHTakenvalue === ONE
                  ? ONE_CRH_QUESTION_ANSWER_1
                  : OTHER_CRH_QUESTION_ANSWER_1
              }
              isSelected={CRHWithTermExtensionTakenValue === ZERO}
              onChange={() => onCRHWithExtensionCountChange(ZERO)}
              disabled={false}
            />
            <RadioButton
              name="CRHWithExtensionCount"
              label={
                CRHTakenvalue === ONE
                  ? ONE_CRH_QUESTION_ANSWER_2
                  : OTHER_CRH_QUESTION_ANSWER_2
              }
              isSelected={CRHWithTermExtensionTakenValue === ONE}
              onChange={() => onCRHWithExtensionCountChange(ONE)}
              disabled={false}
            />
            <VisibleSection
              visible={CRHTakenvalue === TWO || CRHTakenvalue === THREE}
            >
              <RadioButton
                name="CRHWithExtensionCount"
                label={
                  CRHTakenvalue === TWO
                    ? TWO_CRH_QUESTION_ANSWER_3
                    : THREE_CRH_QUESTION_ANSWER_3
                }
                isSelected={CRHWithTermExtensionTakenValue === TWO}
                onChange={() => onCRHWithExtensionCountChange(TWO)}
                disabled={false}
              />
              <VisibleSection visible={CRHTakenvalue === THREE}>
                <RadioButton
                  name="CRHWithExtensionCount"
                  label={THREE_CRH_QUESTION_ANSWER_4}
                  isSelected={CRHWithTermExtensionTakenValue === THREE}
                  onChange={() => onCRHWithExtensionCountChange(THREE)}
                  disabled={false}
                />
              </VisibleSection>
            </VisibleSection>
          </div>
        </fieldset>
      </VisibleSection>
    </>
  );
};
